module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "80px"
    }
  }, [_c('form', {
    staticClass: "form-inline",
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group pt5px mr30px"
  }, [_c('label', [_c('radio', {
    attrs: {
      "true-value": "1"
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, [_vm._v("导入正式车辆")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group pt5px mr30px"
  }, [_c('label', [_c('radio', {
    attrs: {
      "true-value": "6"
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, [_vm._v("导入测试车辆")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group pt5px mr30px"
  }, [_c('label', [_c('radio', {
    attrs: {
      "true-value": "2"
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, [_vm._v("设备更换")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group pt5px mr30px"
  }, [_c('label', [_c('radio', {
    attrs: {
      "true-value": "3"
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, [_vm._v("设备(整机)更换")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group pt5px mr30px"
  }, [_c('label', [_c('radio', {
    attrs: {
      "true-value": "4"
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, [_vm._v("SIM更换")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group pt5px mr30px"
  }, [_c('label', [_c('radio', {
    attrs: {
      "true-value": "5"
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, [_vm._v("设备导入模板")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group pt5px mr30px"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.download
    }
  }, [_vm._v("下载")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-851013e6","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/FileDownload.vue
// module id = 1597
// module chunks = 0